import { render, staticRenderFns } from "./CustomSearchErgoEval.vue?vue&type=template&id=ee70e392&"
import script from "./CustomSearchErgoEval.vue?vue&type=script&lang=js&"
export * from "./CustomSearchErgoEval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports